import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotificacionService {

  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;

  }

  revisarNotificaciones(idUser: number, revisado: number): Observable<any> {
    const intervalo = 600000; //10 min
    this.token = environment.token;    
    if (this.token != '') {      
      return interval(intervalo).pipe(
        switchMap(() => {          
          return this.http.get(this.baseUrl + 'avisosUsuarioRevisado/' + idUser + '/' + revisado, { headers: this.header(this.token) });
        })
      );
    }
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  private headerFile(accessToken: string) {
    let headers = new HttpHeaders({
      //"Content-Type": "multipart/form-data",
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken,
    });
    headers.append("enctype", "multipart/form-data");
    return headers;
  }

  getNotificaciones(): Observable<any> {
    return this.http.get(this.baseUrl + 'listaNotificaciones', { headers: this.header(this.token) });
  }

  getNotificacionesUsuario(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'listaAvisosUsuario/' + id, { headers: this.header(this.token) });
  }


  getGrupos(): Observable<any> {
    return this.http.get(this.baseUrl + 'listaGrupos', { headers: this.header(this.token) });
  }

  postAviso(data: any, file: any): Observable<any> {
    const fd: FormData = new FormData();
    fd.append('file', file);
    fd.append('titulo_aviso', data.titulo_aviso);
    fd.append('detalle_aviso', data.detalle_aviso);
    fd.append('tipo_aviso', data.tipo_aviso);
    fd.append('grupo_id', data.grupo_id);
    fd.append('aviso', data.aviso);
    fd.append('enviar_correo', data.enviar_correo);    
    return this.http.post(this.baseUrl + 'registrarNotificacion', fd, { headers: this.headerFile(this.token) });
  }

  putAviso(data: any, file: any): Observable<any> {
    const fd: FormData = new FormData();
    fd.append('file', file);
    fd.append('id', data.id);
    fd.append('titulo_aviso', data.titulo_aviso);
    fd.append('detalle_aviso', data.detalle_aviso);
    fd.append('tipo_aviso', data.tipo_aviso);
    fd.append('grupo_id', data.grupo_id);
    fd.append('aviso', data.aviso);
    fd.append('enviar_correo', data.enviar_correo);
    return this.http.post(this.baseUrl + 'actualizarNotificacion', fd, { headers: this.headerFile(this.token) });
  }

  deleteAviso(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'eliminarNotificacion/' + id, { headers: this.header(this.token) });
  }

  inactivarNotificacion(id: number) {
    return this.http.delete(this.baseUrl + 'inactivarNotificacion/' + id, { headers: this.header(this.token) });
  }


  postGrupo(notificacion: any): Observable<any> {
    return this.http.post(this.baseUrl + 'registrarGrupo', notificacion, { headers: this.header(this.token) });
  }

  putGrupo(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'actualizarGrupo', bodyString, { headers: this.header(this.token) });
  }

  deleteGrupo(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'eliminarGrupo/' + id, { headers: this.header(this.token) });
  }


  getUsuariosGrupo(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'getUsuariosAsignadosGrupo/' + id, { headers: this.header(this.token) });
  }

  postUsuariosGrupo(data: any): Observable<any> {

    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'postUsuariosGrupo', bodyString, { headers: this.header(this.token) });
  }


  avisosUsuariosPorUsuarioRevisado(idUser: number, revisado: number) {
    return this.http.get(this.baseUrl + 'avisosUsuarioRevisado/' + idUser + '/' + revisado, { headers: this.header(this.token) });
  }

  cambiarEstadoRevisado(data: any): Observable<any> {    
    let bodyString = JSON.stringify(data);    
    return this.http.put(this.baseUrl + 'cambiarEstadoRevisado', bodyString, { headers: this.header(this.token) });    
  }  

}